// A timeout is set between every print action to refrain the user from printing too much at a time. If true, labels may be printed
export const setLabelPrinterTimeoutFinished = (labelPrinterTimeoutFinished) => {
    return {
        type: "SET_LABEL_PRINTER_TIMEOUT_FINISHED",
        payload: labelPrinterTimeoutFinished
    }
};
